import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import type { IBindingProps } from "@frui.ts/views";
import React from "react";
import countryFilter from "@edaz/utils/countryFilter";
import type CountrySelectViewModel from "../../viewModels/countrySelectViewModel";

export interface CountrySelectProps<TTarget> extends IBindingProps<TTarget> {
  vm: CountrySelectViewModel;
  allowEmpty?: boolean;
  disabled?: boolean;
  placeholder?: string;
  onlySEPACountries?: boolean;
  menuFixed?: boolean;
}

function CountrySelect<TTarget>(props: CountrySelectProps<TTarget>) {
  let items;
  if (props.onlySEPACountries) {
    items = props.vm.countrySEPAOptions;
  } else {
    items = props.vm.countryOptions;
  }

  return (
    <AdvancedSelect
      menuPosition={props.menuFixed ? "fixed" : undefined}
      target={props.target}
      property={props.property}
      items={items}
      allowEmpty={props.allowEmpty}
      disabled={props.disabled}
      placeholder={props.placeholder}
      filterOption={countryFilter}
    />
  );
}

export default CountrySelect;
